import Mapper from '@/models/mappers/Mapper';
import { mapValueToInterface } from '@/utils/models';
import { ProductCategoryAttribute } from '@/models/entities/ProductCategoryAttribute';
import { ProductCategoryAttributeDTO } from '@/api/dto/ProductCategoryAttributeDTO';

export class ProductCategoryAttributeMapper extends Mapper<
  ProductCategoryAttribute,
  ProductCategoryAttributeDTO
> {
  mapFromDTO(
    productCategoryAttributeDTO: ProductCategoryAttributeDTO,
  ): ProductCategoryAttribute {
    return new ProductCategoryAttribute(
      <Partial<ProductCategoryAttribute>>productCategoryAttributeDTO,
    );
  }

  mapToDTO(
    productCategoryAttribute: ProductCategoryAttribute,
  ): ProductCategoryAttributeDTO {
    return mapValueToInterface(productCategoryAttribute) as ProductCategoryAttributeDTO;
  }
}
